import { createAction, props } from '@ngrx/store';

export const setTotalPremiumDifferenceAction = createAction(
  '[TOTALPREMIUMDIFFERENCE] Set Total Premium Difference',
  props<{ totalPremiumDifference: number }>()
);
